import { ColDef } from 'ag-grid-enterprise';
import { alignLeft, alignRight } from './utils';
import { formatSideAdapter } from './common';
import { CompanyInfo } from '@/modules/common/models';
import Decimal from 'decimal.js';
import * as cols from './common';
import { SponsoredLoanDetailsResponseItem } from '@/modules/sponsorship/models';
import { Side } from '@/modules/sponsorship/models/sponsored-loan-basket';
export { errorRow, errorField, errorMessage } from './common';

export function side(config: { side: Side }): ColDef<SponsoredLoanDetailsResponseItem, number> {
  return {
    colId: 'side',
    headerName: 'Side',
    cellRendererSelector: () =>
      formatSideAdapter({
        side: config.side,
      }),
    ...alignLeft(),
  };
}

export function counterparty(): ColDef<SponsoredLoanDetailsResponseItem, CompanyInfo> {
  return {
    field: 'counterparty',
    colId: 'counterparty',
    headerName: 'Counterparty',
    sortable: false,
    valueFormatter: (params) =>
      !params.value ? '–' : `${params.value.companyName} (${params.value.displayId})`,
    cellDataType: 'text',
    ...alignLeft(),
  };
}

export function ticker(): ColDef<SponsoredLoanDetailsResponseItem, string> {
  return {
    field: 'security.ticker',
    colId: 'ticker',
    headerName: 'Ticker',
    sortable: false,
    cellDataType: 'text',
    ...alignLeft(),
  };
}

export function cusip(): ColDef<SponsoredLoanDetailsResponseItem, string> {
  return {
    field: 'security.cusip',
    colId: 'cusip',
    headerName: 'CUSIP',
    sortable: false,
    cellDataType: 'text',
    ...alignLeft(),
  };
}

export function quantity(): ColDef<SponsoredLoanDetailsResponseItem, number> {
  return cols.quantity({
    field: 'quantity',
    colId: 'quantity',
    headerName: 'Quantity',
    dashWhenZero: true,
  });
}

export function rate(): ColDef<SponsoredLoanDetailsResponseItem, Decimal> {
  return {
    field: 'rate',
    colId: 'rate',
    headerName: 'Rebate Rate',
    sortable: false,
    cellRendererSelector: (params) =>
      cols.rateAdapter({
        rate: params.value,
        rateModifier: undefined,
      }),
    cellDataType: 'text',
    ...alignRight({ hasPostfix: true }),
  };
}
